// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IUpdateProcessingRuleTierDto
 */
export interface IUpdateProcessingRuleTierDto {
    /**
     * 
     * @type {number}
     * @memberof IUpdateProcessingRuleTierDto
     */
    processing_tier_id: number;
    /**
     * 
     * @type {string}
     * @memberof IUpdateProcessingRuleTierDto
     */
    payout_rule_type: IUpdateProcessingRuleTierDtoPayoutRuleTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof IUpdateProcessingRuleTierDto
     */
    is_lock_purse?: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof IUpdateProcessingRuleTierDto
     */
    plan_ids?: Array<number>;
}

/**
* @export
* @enum {string}
*/
export enum IUpdateProcessingRuleTierDtoPayoutRuleTypeEnum {
    NO_EXCEPTIONS = 'NO_EXCEPTIONS',
    WITH_EXCEPTIONS = 'WITH_EXCEPTIONS',
    EXCEPTIONS_ONLY = 'EXCEPTIONS_ONLY'
}


/**
 * Check if a given object implements the IUpdateProcessingRuleTierDto interface.
 */
export function instanceOfIUpdateProcessingRuleTierDto(value: object): value is IUpdateProcessingRuleTierDto {
    if (!('processing_tier_id' in value) || value['processing_tier_id'] === undefined) return false;
    if (!('payout_rule_type' in value) || value['payout_rule_type'] === undefined) return false;
    return true;
}

export function IUpdateProcessingRuleTierDtoFromJSON(json: any): IUpdateProcessingRuleTierDto {
    return IUpdateProcessingRuleTierDtoFromJSONTyped(json, false);
}

export function IUpdateProcessingRuleTierDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IUpdateProcessingRuleTierDto {
    if (json == null) {
        return json;
    }
    return {
        
        'processing_tier_id': json['processing_tier_id'],
        'payout_rule_type': json['payout_rule_type'],
        'is_lock_purse': json['is_lock_purse'] == null ? undefined : json['is_lock_purse'],
        'plan_ids': json['plan_ids'] == null ? undefined : json['plan_ids'],
    };
}

export function IUpdateProcessingRuleTierDtoToJSON(json: any): IUpdateProcessingRuleTierDto {
    return IUpdateProcessingRuleTierDtoToJSONTyped(json, false);
}

export function IUpdateProcessingRuleTierDtoToJSONTyped(value?: IUpdateProcessingRuleTierDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'processing_tier_id': value['processing_tier_id'],
        'payout_rule_type': value['payout_rule_type'],
        'is_lock_purse': value['is_lock_purse'],
        'plan_ids': value['plan_ids'],
    };
}

